{
  "version": 1,
  "gtdPath": "/roam/gtd.org",
  "dailyPathTemplate": "/roam/daily/YYYY-MM-DD.org",
  "buttons": [
    { "label": "", "path": "", "icon": "file-alt" },
    { "label": "", "path": "", "icon": "file-alt" },
    { "label": "", "path": "", "icon": "file-alt" },
    { "label": "", "path": "", "icon": "file-alt" },
    { "label": "", "path": "", "icon": "file-alt" },
    { "label": "", "path": "", "icon": "file-alt" },
    { "label": "", "path": "", "icon": "file-alt" },
    { "label": "", "path": "", "icon": "file-alt" }
  ]
}
